import type { TimelineElement } from '../../../types/timelineElement'
import type { ScopedChild } from './scopeChildren'

export interface WindowMs { readonly startMs: number; readonly endMs: number }

const descendantsOf = (element: TimelineElement, elementsById: ReadonlyMap<string, TimelineElement>): TimelineElement[] =>
  [...elementsById.values()].filter((candidate) => {
    let parentId = candidate.parentId
    while (parentId) {
      if (parentId === element.id) return true
      parentId = elementsById.get(parentId)?.parentId ?? null
    }
    return false
  })

export function remainingWeightSeries(
  parents: readonly ScopedChild[],
  elementsById: ReadonlyMap<string, TimelineElement>,
  window: WindowMs,
  ticks: number,
): number[][] {
  const count = Math.max(0, Math.floor(ticks))
  const weightCache = new WeakMap<TimelineElement, number>()
  const weightOf = (element: TimelineElement): number => {
    const cached = weightCache.get(element)
    if (cached !== undefined) return cached
    const value = element.weight > 0
      ? element.weight
      : descendantsOf(element, elementsById).filter((child) => child.parentId === element.id).reduce((sum, child) => sum + weightOf(child), 0) || 1
    weightCache.set(element, value)
    return value
  }
  return parents.map((parent) => {
    const weight = parent.checklistItem?.weightage ?? (parent.element ? weightOf(parent.element) : 1)
    const complete = parent.checklistItem?.isCompleted ?? parent.element?.boardStatus === 'COMPLETE'
    return Array.from({ length: count }, (_, index) => {
      const tick = count <= 1 ? window.startMs : window.startMs + index * (window.endMs - window.startMs) / (count - 1)
      return complete && tick >= window.endMs ? 0 : weight
    })
  })
}
